import axios from 'axios';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Config from '../config';
import {
    CREATE_AND_CLOSE_BUTTON,
    FEEDBACK_MODAL_CLOSE,
    FORMAT_MODAL_CLOSE,
    LOADING_MODAL_CLOSE,
    LOADING_MODAL_OPEN,
    MODAL_CLOSE,
    MODAL_OPEN,
    PROPERTY_MODAL_CLOSE,
    STYLE_MODAL_CLOSE
} from './actions';
import Cookies from 'js-cookie';
import { NAVIGATE_STITCHING_WITH_ACC, NAVIGATE_STITCHING_WITH_ACC_LAST } from './programs/StitchingDC/stitchingDC/stitchingDC.actionsType';
import { LOADING_SALES_ORDER_DEMAND, NAVIGATE_SALES_ORDER_DETAILS } from './salesOrder/salesOrder.actionsType';
import { PREVLIST_LOADER_INDICATION } from './programs/FabricPo/fabricPoDetails/fabricPoDetails.actionsType';
import { PREVLIST_LOADER_INDICATION_STYLE } from './stylePreparations/processCostPerKg/processCostPerKg.actionsType';





const instance = axios.create({
    baseURL: `${Config.baseUrl}`,
    withCredentials: false,
    headers: {
        'Access-Control-Allow-Origin': true,
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Content-Type': 'application/json'
    },
    // validateStatus: status => status < 500
});

export default function axiosCall(config, isDetail, loader) {
    return async (dispatch) => {
        let {
            method,
            url,
            responseTypeRequest,
            responseTypeSuccess,
            responseTypeFailure,
            data,
            headers,
            payload,
            resetFormData,
            modalClose,
            getAllData,
            singlApiArray,
            propertyModal,
            styleModal,
            formatModal,
            modalId,
            feedbackModalClose,
            PoDcInwardNo,
            PoDcInwardType,
            isPopupOpen,
            successMsg,
            errorMsg,
            msg,
            accessoryMessage = false,
            detailEdit,
            rowData,
            salesOrderListById
        } = config;

        const apiData = data
            ? {
                method,
                url,
                data,
                headers: {
                    ...headers,
                    Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                    dbname: Cookies.get('DATABASE')
                }
            }
            : {
                method,
                url,
                headers: {
                    Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                    dbname: Cookies.get('DATABASE')
                }
            };
        dispatch({ type: responseTypeRequest });
        instance(apiData)
            .then((response) => {

                if (responseTypeRequest === 'DELETE_PROCESS_COST_PER_PCS_REQUEST' && response.data !== 200) {
                    toast.error(response.data);
                }


                if (responseTypeRequest === 'CREATE_STITCHING_DC_DETAILS_REQUEST' && response.status === 200 && !isDetail) {
                    dispatch({ type: MODAL_CLOSE });
                    setTimeout(() => {
                        // dispatch({ type: NAVIGATE_STITCHING_WITH_ACC })
                        dispatch({ type: NAVIGATE_STITCHING_WITH_ACC_LAST })
                        dispatch({ type: MODAL_OPEN });
                        // dispatch({ type: LOADING_MODAL_CLOSE });
                    }, 1000)
                }
                // if we enable delivery note then enable this or else no need
                // if (responseTypeRequest === 'GET_DN_POST_REQUEST' && response.status === 200 && !isDetail) {
                //     dispatch({ type: MODAL_CLOSE });
                //     setTimeout(() => {
                //         dispatch({ type: NAVIGATE_STITCHING_WITH_ACC_LAST })
                //         dispatch({ type: MODAL_OPEN });
                //     }, 1000)
                // }


                // if (responseTypeRequest === 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST' && response.status === 200) {
                //     dispatch({ type: LOADING_MODAL_CLOSE });
                // } else {
                //     dispatch({ type: LOADING_MODAL_OPEN });
                // }

                if (responseTypeRequest === 'FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST' && response.status === 200) {
                    dispatch({
                        type: PREVLIST_LOADER_INDICATION,
                        payload: { previousGetLoader: false }
                    })
                }


                if (responseTypeRequest === 'FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_REQUEST' && response.status === 200) {
                    dispatch({
                        type: PREVLIST_LOADER_INDICATION_STYLE,
                        payload: { previousGetLoader: false }
                    })

                }

                // if (responseTypeSuccess === 'UPDATE_SALES_ORDER_SUCCESS' && detailEdit == true) {

                //     dispatch({
                //         type: NAVIGATE_SALES_ORDER_DETAILS,
                //         updatePayload: { singleSalesOrder: rowData, isHeaderScreen: true }
                //     });
                //     dispatch({ type: MODAL_OPEN });

                //     dispatch(fetchStyleNumberBySeason(rowData?.fldFkSeason, rowData?.fldFkSize));
                //     dispatch(fetchHSNMaster());
                //     dispatch(fetchSizeRatioById(rowData?.fldFkSize));
                //     dispatch(fetchCommonPropertyById(25)); //Type Of Packing
                //     dispatch(fetchCommonPropertyById(22)); //Unit of Measurement
                //     dispatch(fetchStyleMasterDropdown(rowData?.fldId));
                //     dispatch(fetchSubStyleNumberDropdown(rowData?.fldId));
                //     dispatch({ type: CREATE_AND_CLOSE_BUTTON });

                //     if (salesOrderListById?.length > 0) {
                //         dispatch(getSingleSalesOrderDetails(salesOrderListById[0]?.fldId, rowData?.fldFkSeason, rowData?.fldFkSize));

                //         dispatch(getSingleSalesOrderDetailsEanNumber(salesOrderListById[0]?.fldFkStyleMaster, rowData?.fldId, salesOrderListById[0]?.tblStyleMasterSubStyleId.fldId));

                //         // dispatch(salesOrderDetailsCheckGet(salesOrderListById[0]?.fldFkStyleMaster, singleSalesOrderData?.fldId))

                //         dispatch(fetchStyleDetailById(salesOrderListById[0]?.fldFkStyleMaster))
                //         dispatch({ type: EDIT_MODAL_HEADER_DETAIL })

                //         // setEditModal(true)

                //     }


                // }


                if (response.data || response.status === 200) {

                    if (loader === true) {
                        dispatch({ type: LOADING_MODAL_OPEN });
                        if (modalClose) {
                            dispatch({ type: MODAL_CLOSE });
                            dispatch({ type: LOADING_MODAL_CLOSE });
                        }
                    } else {
                        dispatch({ type: LOADING_MODAL_CLOSE });
                    }

                    if (response.data === 'Demand Generated Successfully') {
                        dispatch({ type: LOADING_SALES_ORDER_DEMAND, payload: false })
                        toast.success(response.data, { autoClose: 1500 })
                    }

                    if (responseTypeRequest === 'GET_LOADING_SALES_ORDER_REQUEST' && response.status === 524) {
                        dispatch({ type: LOADING_SALES_ORDER_DEMAND, payload: false })
                    }
                    dispatch({ type: responseTypeSuccess, updatePayload: response.data, payload });
                    if (singlApiArray && singlApiArray.length > 0) {
                        singlApiArray.forEach(async (element) => {
                            await dispatch(element);
                        });
                    }
                    if (method === 'post') {
                        getAllData && dispatch(getAllData);
                        if (!isPopupOpen && !PoDcInwardNo) {
                            successMsg
                                ? toast.success(successMsg, { autoClose: 1500 })
                                : toast.success('Data created successfully', { autoClose: 1500 });
                        }
                    } else if (method === 'patch') {
                        getAllData && dispatch(getAllData);
                        toast.success('Data updated successfully', { autoClose: 1500 });
                    } else if (method === 'delete') {
                        getAllData && dispatch(getAllData);
                        toast.success('Data deleted successfully', { autoClose: 1500 });
                    }
                    //else if (method === 'get') {
                    //     msg && toast.success(`${msg}`, { autoClose: 1500 });
                    //     accessoryMessage &&
                    //         Swal.fire({
                    //             html: `${response.data == 'Demand Generated Successfully'
                    //                 ? `<h2 style="color: green;">${response?.data}<h2/>`
                    //                 : `<h2 style="color: red; font-weight: bold">${response?.data}</h2>`
                    //                 }`,
                    //             showCancelButton: true,
                    //             cancelButtonColor: 'grey',
                    //             allowOutsideClick: false,

                    //             cancelButtonText: 'Close',
                    //             showConfirmButton: false
                    //         });
                    // }
                    if (modalClose && !detailEdit) {
                        dispatch({ type: MODAL_CLOSE });

                    }
                    if (resetFormData) {
                        dispatch({ type: resetFormData });
                    }
                    if (styleModal) {
                        dispatch({ type: STYLE_MODAL_CLOSE, id: modalId });
                    }
                    if (formatModal) {
                        dispatch({ type: FORMAT_MODAL_CLOSE, id: modalId });
                    }
                    if (propertyModal) {
                        dispatch({ type: PROPERTY_MODAL_CLOSE, id: modalId });
                    }
                    if (feedbackModalClose) {
                        dispatch({ type: FEEDBACK_MODAL_CLOSE, id: modalId });
                    }
                    if (isPopupOpen && PoDcInwardNo && response?.data.length > 0) {
                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your ${PoDcInwardType === 'PO' ? 'PO NO' : PoDcInwardType === 'Inward' ? 'Inward No' : PoDcInwardType === 'DC' ? 'DC NO' : ''} ${response?.data[0][`${PoDcInwardNo}`]}`

                        });
                    }


                    if (isPopupOpen && PoDcInwardNo === 'fldCRFNo' && response?.data.length > 0) {
                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your CRF No.${response?.data}`
                        });
                    }

                    if (isPopupOpen && PoDcInwardNo === 'ARLNo' && response?.data) {
                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your ARL No.${response?.data}`
                        });
                    }


                    if (isPopupOpen && PoDcInwardNo === 'fldBRNo' && response?.data) {
                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your BR No.${response?.data}`
                        });
                    }

                    if (isPopupOpen && PoDcInwardNo === 'BillEntry' && response?.data.length > 0) {
                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your ARL No.${response?.data}`
                        });
                    }
                    if (isPopupOpen && PoDcInwardNo === 'VerifyEntry' && response) {
                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your Verification No.${response?.data}`
                        });
                    }

                    if (isPopupOpen && PoDcInwardNo === 'GeneralPoInwardNo' && response) {

                        Swal.fire({
                            icon: 'success',
                            text: `Please note down your Inward No.${response?.data?.fldInwardNo}`
                        });
                    }
                    return response.data;
                } else {
                    dispatch({ type: responseTypeSuccess, updatePayload: response.data, payload });
                    if (typeof response.data === 'boolean') {
                        !response.data && toast.error('Please select Default value', { autoClose: 1500 });
                    }
                    return response.data;
                }
            })
            .catch((err) => {
                let errorMessage = err.toJSON()
                // console.log('errorMessage', errorMessage)
                // if (err.response?.status === 500) {
                //     toast.error(errorMessage.message)
                //     dispatch({ type: LOADING_MODAL_CLOSE });
                // }

                if (err?.response?.status === 524) {
                    console.log('failed due to timeouts')
                    dispatch({ type: LOADING_SALES_ORDER_DEMAND, payload: false })
                }

                if (err.response?.status === 409 && method === 'patch') {
                    toast.error(errorMessage.message)
                    //dispatch({ type: LOADING_MODAL_CLOSE });
                }

                if (err?.response?.status === 401) {
                    Cookies.remove('JWT_TOKEN');
                    Cookies.remove('USER');
                    Cookies.remove('DATABASE');
                    Cookies.remove('USERID');
                    Cookies.remove('PASSWORD');
                    Cookies.remove('URL');
                    window.location.replace(`${window.location.pathname}`);
                    dispatch({ type: LOADING_MODAL_CLOSE });
                }
                if (err.response && err.response.data && err.response.data.error === 'Authentication token expired') {
                    localStorage.clear();
                }
                dispatch({
                    type: responseTypeFailure,
                    updatePayload: err.response ? err.response : 'Something Went Wrong.'
                });
                if (method !== 'get') {
                    toast.error(err?.response?.data['']?.errors[0]?.errorMessage ?? err?.response?.data?.title ?? err?.response?.data);
                }
                if (method === 'get') {
                    errorMsg && toast.error(errorMsg);
                }
                dispatch({ type: LOADING_MODAL_CLOSE });
                return err.response;
            });
    };
}
